import { borderRadius, Card, SpaceBetween, spacing, styled, TextElement } from '@lessonup/ui-components';
import React from 'react';

export interface OptionCardProps {
  title: string;
  titleIcon?: React.ReactNode;
  description: string;
  tagline?: string;
  taglineIcon?: React.ReactNode;
  image?: string;
  onClick: () => void;
  active?: boolean;
}

export const OptionCard: React.FC<OptionCardProps> = ({
  title,
  titleIcon,
  description,
  tagline,
  taglineIcon,
  image,
  onClick,
  active,
}) => {
  return (
    <Card resizing="fixed" active={active} onClick={onClick}>
      <CardContentWrapper direction="x" spacing={spacing.size8}>
        <StyledTextWrapper width={image ? '50%' : '100%'}>
          {tagline && (
            <StyledTagline textStyle="caption" size="small" weight="bold" style={{ margin: 'auto' }}>
              {taglineIcon}
              {tagline}
            </StyledTagline>
          )}
          <StyledTitle textStyle="bodyText" size="small" weight="bold">
            {titleIcon}
            {title}
          </StyledTitle>
          <TextElement textStyle="bodyText">{description}</TextElement>
        </StyledTextWrapper>
        {image && <StyledImage src={image} />}
      </CardContentWrapper>
    </Card>
  );
};

const CardContentWrapper = styled(SpaceBetween)`
  height: 100%;
  width: 100%;
  display: flex;
`;

const StyledTagline = styled(TextElement)`
  display: flex;
  align-items: center;
  gap: ${spacing.size8};
`;

const StyledTextWrapper = styled.div<{ width: string }>`
  width: ${(props) => props.width};
  margin: ${spacing.size16};
`;

const StyledTitle = styled(TextElement)`
  display: flex;
  align-items: center;
  gap: ${spacing.size8};
`;

const StyledImage = styled.div<{ src: string }>`
  background-image: url(${(props) => props.src});
  width: 50%;
  height: 0;
  padding-top: 25%;
  margin: ${spacing.size16};
  border-radius: ${borderRadius.rounded8};
  background-size: cover;
  background-position: center;
`;
